webpackJsonp([1],{

/***/ "+vOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Axios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Axios_service__ = __webpack_require__("I6up");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Api_service__ = __webpack_require__("VOQ9");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Api_service__["a"]; });



var Axios = {
    Server: new __WEBPACK_IMPORTED_MODULE_0__Axios_service__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].ServerUrl),
    Api: new __WEBPACK_IMPORTED_MODULE_0__Axios_service__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].ApiUrl)
};

/***/ }),

/***/ "/672":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BarExample__ = __webpack_require__("bhN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Activity_NowActivity_vue__ = __webpack_require__("/pOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarExample: __WEBPACK_IMPORTED_MODULE_0__BarExample__["a" /* default */],
    Activity: __WEBPACK_IMPORTED_MODULE_1__Activity_NowActivity_vue__["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        ghostClass: 'ghost',
        sort: false
      },
      dataPoints: null,
      height: 20,
      drag: false,
      draggedId: false,
      hoverId: false,
      myArray: {
        name: 'Report',
        children: [{
          level: 0,
          name: 'afafa',
          children: []
        }, {
          level: 0,
          name: 'afafa2',
          children: []
        }, {
          level: 0,
          name: 'afafa3',
          children: []
        }, {
          level: 0,
          name: 'afafa4',
          children: []
        }, {
          level: 0,
          name: 'afafa5',
          children: []
        }, {
          level: 0,
          name: 'afafa6',
          children: []
        }]
      },

      amount: '',
      project: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.fillData();
    }, 2000);
  },

  methods: {
    hover: function hover(e) {
      this.hoverId = e.target.id;
    },
    MoveCallback: function MoveCallback(e, e2) {
      console.log('eee', e);
    },
    onStart: function onStart(e) {
      this.drag = true;
      console.log('eeee', e);
      this.draggedId = e.item.id;
    },
    onEnd: function onEnd(e) {
      var _this2 = this;

      this.drag = false;
      var targetIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(this.myArray, function (elem) {
        return elem.name === _this2.hoverId;
      });
      var draggedIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(this.myArray, function (elem) {
        return elem.name === _this2.draggedId;
      });
      if (targetIndex !== -1 && draggedIndex !== -1 && targetIndex !== draggedIndex) {
        //let targetLevel =
        var newElem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.myArray[draggedIndex]);
        newElem.level++;
        this.myArray[targetIndex].children.push(newElem);
        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(this.myArray, function (elem) {
          return elem.name === _this2.draggedId;
        });
      }
      this.draggedId = false;
      this.hoverId = false;
      console.log('this.myArray', this.myArray);
    },
    recIn: function recIn(obj) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return obj.children.length > 0 ? this.recIn(obj.children[0], index = index + 1) : index++;
    },
    moved: function moved(e1, e2, e3) {},
    increaseHeight: function increaseHeight() {
      this.height += 10;
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    fillData: function fillData() {
      this.dataPoints = {
        labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
        }]
      };
    },
    submit: function submit() {
      var params = {
        amount: this.amount,
        project: this.project
      };

      __WEBPACK_IMPORTED_MODULE_2__services__["a" /* Api */].Payments().post(params).then(function (response) {
        console.log(response);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {
    myStyles: function myStyles() {
      return {
        height: this.height + 'px',
        position: 'relative'
      };
    }
  }
});

/***/ }),

/***/ "/ek7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavBar_vue__ = __webpack_require__("uewz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MainTemplate_vue__ = __webpack_require__("VwHg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SideBar_vue__ = __webpack_require__("Xu7m");






/* harmony default export */ __webpack_exports__["a"] = ({
    NavBar: __WEBPACK_IMPORTED_MODULE_0__NavBar_vue__["a" /* default */],
    MainTemplate: __WEBPACK_IMPORTED_MODULE_1__MainTemplate_vue__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__Loader_vue__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_3__SideBar_vue__["a" /* default */]
});

/***/ }),

/***/ "/pOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowActivity_vue__ = __webpack_require__("3ROF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73151936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowActivity_vue__ = __webpack_require__("xty0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowActivity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73151936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowActivity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "02Jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-4",attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('UsersPerProjectPickers',{on:{"change":_vm.requestData}}),_vm._v(" "),(_vm.loading)?_c('Loader'):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.items),function(user){return _c('v-layout',{key:user.id,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"height-auto"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-avatar',{attrs:{"slot":"activator","size":"76px"},slot:"activator"},[_c('img',{attrs:{"src":user.avatar_url,"alt":""}})]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline card-title-margin"},[_vm._v(_vm._s(user.first_name))])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(" "+_vm._s(user.last_name))])])],1),_vm._v(" "),_c('v-list',{staticClass:"height",attrs:{"two-line":""}},[_c('v-list-tile',{staticClass:"list-tile-margin",on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                        Total Revenue: "+_vm._s(user.Analytics.Revenue)+"$\n                                    ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-list-tile',{staticClass:"list-tile-margin",on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("all_inclusive")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                        Total Hours: "+_vm._s(user.Analytics.totalHours)+"\n                                    ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{staticClass:"list-tile-margin",on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_up")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                        Total Billable Hours: "+_vm._s(user.Analytics.billableHours)+"\n                                    ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{staticClass:"list-tile-margin",on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_flat")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                                        Total Non Billable Hours: "+_vm._s(user.Analytics.nonBillableHours)+"\n                                    ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"height-auto"},[_c('v-card-title',[_vm._v("\n                                    Time Tracking\n                                ")]),_vm._v(" "),_c('UserPerProjectBarChart',{attrs:{"analytics":user.Analytics}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"height-auto"},[_c('v-card-title',[_vm._v("\n                                    Time Tracking\n                                ")]),_vm._v(" "),_c('UserPerProjectPieChart',{attrs:{"analytics":user.Analytics}})],1)],1)],1)],1)],1)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      subdomain: 'hat',
      client_id: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].client_id,
      redirect_uri: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].redirect_uri
    };
  },
  created: function created() {
    var parsed = __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(location.search);
    if (parsed.code) {
      this.$router.push('/auth?' + location.search);
    }
  },

  methods: {
    auth: function auth() {
      var uri2 = 'https://id.getharvest.com/oauth2/authorize?client_id=' + this.client_id + '&response_type=code&redirect_uri=' + this.redirect_uri;
      console.log('uri', uri2);
      window.location = uri2;
      // return Api.Auth().signIn()
    }
  }
});

/***/ }),

/***/ "0YGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentForm_vue__ = __webpack_require__("fcdg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e1e9a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentForm_vue__ = __webpack_require__("oizg");
function injectStyle (ssrContext) {
  __webpack_require__("lsD3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e1e9a7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0ZlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__("lrD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c98e1ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__("M8ne");
function injectStyle (ssrContext) {
  __webpack_require__("d2P5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c98e1ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1CQK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeSheetsTable_vue__ = __webpack_require__("3he/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimeSheetPickers_vue__ = __webpack_require__("3Jnw");
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            loading: true
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__["a" /* default */],
        TimeSheetsTable: __WEBPACK_IMPORTED_MODULE_3__TimeSheetsTable_vue__["a" /* default */],
        TimeSheetPickers: __WEBPACK_IMPORTED_MODULE_4__TimeSheetPickers_vue__["a" /* default */]
    },
    created: function created() {},

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this = this;

            console.log('params!!!!1', params);
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Timesheets().get(params).then(function (res) {
                return _this.items = res.data;
            }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "1rI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2CaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    ServerUrl: 'https://harvest.grandiz.com',
    ApiUrl: 'https://harvest.grandiz.com/api/v1',
    client_id: 'cu_rsZPK-qWvCY_ixEZ2-YMX',
    redirect_uri: 'https://harvest.grandiz.com/'
});

/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dev__ = __webpack_require__("7G+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prod__ = __webpack_require__("2CaA");



var outConfig = {};

switch (true) {
    case window.location.hostname.indexOf('localhost') !== -1:
        outConfig = __WEBPACK_IMPORTED_MODULE_0__dev__["a" /* default */];

        break;
    case window.location.hostname.indexOf('localhost') === -1:
        outConfig = __WEBPACK_IMPORTED_MODULE_1__prod__["a" /* default */];

        break;

    default:
        outConfig = __WEBPACK_IMPORTED_MODULE_0__dev__["a" /* default */];

        break;
}

/* harmony default export */ __webpack_exports__["a"] = (outConfig);

/***/ }),

/***/ "3Jnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSheetPickers_vue__ = __webpack_require__("m4o3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a50dcdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSheetPickers_vue__ = __webpack_require__("rWqx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSheetPickers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a50dcdb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSheetPickers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3ROF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NowActivityTable_vue__ = __webpack_require__("58un");

//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            loading: true
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__["a" /* default */],
        NowActivityTable: __WEBPACK_IMPORTED_MODULE_4__NowActivityTable_vue__["a" /* default */]
    },
    created: function created() {
        this.requestData({});
    },

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this = this;

            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_1__services__["a" /* Api */].Timesheets().get(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params, {
                is_running: true
            })).then(function (res) {
                return _this.items = res.data;
            }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "3he/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSheetsTable_vue__ = __webpack_require__("hbxR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12361535_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSheetsTable_vue__ = __webpack_require__("EjuG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSheetsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12361535_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSheetsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3oRF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('img',{attrs:{"src":__webpack_require__("IVUo")}}),_vm._v(" "),_c('h2',[_vm._v("Welcome to Harvest Analytics")]),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"primary"},on:{"click":_vm.auth}},[_vm._v("AUTHORIZE in Harvest")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4N1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.from_menu),callback:function ($$v) {_vm.from_menu=$$v},expression:"from_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.to_menu),callback:function ($$v) {_vm.to_menu=$$v},expression:"to_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "58un":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowActivityTable_vue__ = __webpack_require__("XZD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eecf930_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowActivityTable_vue__ = __webpack_require__("haK+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NowActivityTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eecf930_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NowActivityTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5CC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('v-select',{attrs:{"label":"Included Projects","autocomplete":"","loading":_vm.loading,"multiple":"","chips":"","items":_vm.items,"item-text":"name","item-value":"id","search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("ekz/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb908fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("DYIK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb908fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5HiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"],
  props: ['data'],
  watch: {
    data: function data(newValue) {}
  },
  created: function created() {},
  mounted: function mounted() {
    this.renderChart({
      labels: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.data.projects, 'name'),
      datasets: [{
        label: 'Billable Hours',
        backgroundColor: '#a5a4a4',
        data: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.data.projects, function (project) {
          return project.billableHours.toFixed(2);
        }),
        borderWidth: 1
      }, {
        label: 'Non Billable Hours',
        backgroundColor: '#e0dbdb',
        data: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.data.projects, function (project) {
          return project.nonBillableHours.toFixed(2);
        }),
        borderWidth: 1
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          categoryPercentage: 0.9,
          barPercentage: 0.9
        }]
      }
    });
  }
});

/***/ }),

/***/ "72c7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BarExample__ = __webpack_require__("5HiD");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['analytics'],
    watch: {
        analytics: function analytics(newValue) {
            this.data = newValue;
        }
    },
    components: {
        BarExample: __WEBPACK_IMPORTED_MODULE_0__BarExample__["a" /* default */]
    },
    created: function created() {
        this.data = this.analytics;
    },
    data: function data() {
        return {
            dataPoints: null,
            height: 20,
            data: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        setInterval(function () {
            _this.fillData();
        }, 2000);
    },

    methods: {
        increaseHeight: function increaseHeight() {
            this.height += 10;
        },
        getRandomInt: function getRandomInt() {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
        },
        fillData: function fillData() {
            this.dataPoints = {
                labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [{
                    label: 'Data One',
                    backgroundColor: '#f87979',
                    data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                }]
            };
        }
    },
    computed: {
        myStyles: function myStyles() {
            return {
                height: this.height + 'px',
                position: 'relative'
            };
        }
    }
});

/***/ }),

/***/ "7G+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    ServerUrl: 'http://localhost:3000',
    ApiUrl: 'http://localhost:3000/api/v1',
    client_id: 'GBz3tcl0ERaDnUuaYkbNUSkP',
    redirect_uri: 'http://localhost:8080'
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9d5120d.png";

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8dt8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authorization_vue__ = __webpack_require__("Lu2E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f97da33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authorization_vue__ = __webpack_require__("LDWt");
function injectStyle (ssrContext) {
  __webpack_require__("xCAX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f97da33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authorization_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f97da33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authorization_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8o66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PieExample__ = __webpack_require__("a35H");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['analytics'],
    watch: {
        analytics: function analytics(newValue) {
            this.data = newValue;
        }
    },
    components: {
        PieExample: __WEBPACK_IMPORTED_MODULE_0__PieExample__["a" /* default */]
    },
    created: function created() {
        this.data = this.analytics;
    },
    data: function data() {
        return {
            dataPoints: null,
            height: 20,
            data: []
        };
    },
    mounted: function mounted() {
        var _this = this;

        setInterval(function () {
            _this.fillData();
        }, 2000);
    },

    methods: {
        increaseHeight: function increaseHeight() {
            this.height += 10;
        },
        getRandomInt: function getRandomInt() {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
        },
        fillData: function fillData() {
            this.dataPoints = {
                labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                datasets: [{
                    label: 'Data One',
                    backgroundColor: '#f87979',
                    data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
                }]
            };
        }
    },
    computed: {
        myStyles: function myStyles() {
            return {
                height: this.height + 'px',
                position: 'relative'
            };
        }
    }
});

/***/ }),

/***/ "A+rL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPerUsersPickers_vue__ = __webpack_require__("iHgf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6e14aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPerUsersPickers_vue__ = __webpack_require__("4N1c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPerUsersPickers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca6e14aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPerUsersPickers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A9U2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AOEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-card',{staticClass:"height-auto"},[_c('v-card-title',[_vm._v("\n          Time Tracking\n        ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('Activity')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BITU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-4",attrs:{"fluid":"","grid-list-md":""}},[_c('v-card',{staticClass:"height-auto"},[_c('v-card-title',[_c('span',[_vm._v("Add Payment Income")]),_c('br')]),_vm._v(" "),_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('PaymentForm')],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('ProjectPerUsersPickers',{on:{"change":_vm.requestData}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[(_vm.loading)?_c('Loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center margin-top"},[_c('v-pagination',{attrs:{"length":_vm.params.totalProjects,"circle":""},model:{value:(_vm.params.projectsPage),callback:function ($$v) {_vm.$set(_vm.params, "projectsPage", $$v)},expression:"params.projectsPage"}})],1),_vm._v(" "),_c('table',{staticClass:"width",attrs:{"border":"1"}},[_c('caption',[_vm._v("Users/Projects")]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Users/Projects")]),_vm._v(" "),_vm._l((_vm.data.headers),function(header){return _c('th',{key:header},[_vm._v(_vm._s(header))])})],2),_vm._v(" "),_vm._l((_vm.data.Analytics),function(AnalyticsObject){return _c('tr',{key:AnalyticsObject.User.id},[_c('td',[_c('v-list',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile',{on:{"click":function($event){_vm.goToUser(AnalyticsObject.User.id)}}},[_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(AnalyticsObject.User.first_name)}}),_vm._v(" "),_c('v-list-tile-title',{domProps:{"textContent":_vm._s(AnalyticsObject.User.last_name)}})],1),_vm._v(" "),_c('v-list-tile-avatar',[_c('img',{attrs:{"src":AnalyticsObject.User.avatar_url}})])],1)],1)],1),_vm._v(" "),_vm._l((AnalyticsObject.Analytics),function(ProjectAnalytics){return _c('td',{key:ProjectAnalytics.Project.id},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-list',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("all_inclusive")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(ProjectAnalytics.totalHours)}})],1),_vm._v(" "),_c('v-list-tile-avatar')],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_up")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(ProjectAnalytics.billableHours)}})],1),_vm._v(" "),_c('v-list-tile-avatar')],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_flat")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(ProjectAnalytics.nonBillableHours)}})],1),_vm._v(" "),_c('v-list-tile-avatar')],1)],1),_vm._v(" "),_c('span',[_c('span',[_vm._v(_vm._s(ProjectAnalytics.Project.name))]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('span',[_vm._v("Revenue:"+_vm._s(ProjectAnalytics.Revenue)+"$")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('span',[_vm._v("Total Revenue: "+_vm._s(AnalyticsObject.Revenue)+"$")])],1)],1)],1)})],2)})],2),_vm._v(" "),(!_vm.loading)?_c('v-btn',{attrs:{"round":"","color":"margin-top grey-primary ","disabled":_vm.params.usersPage==_vm.params.totalUsers},on:{"click":_vm.loadMore}},[_vm._v("Load More Users\n            ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('Loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center margin-top "},[_c('v-pagination',{attrs:{"length":_vm.params.totalProjects,"circle":""},model:{value:(_vm.params.projectsPage),callback:function ($$v) {_vm.$set(_vm.params, "projectsPage", $$v)},expression:"params.projectsPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CDWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("c56i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c0abe9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("CrUw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c0abe9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CrUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding"},[_c('Loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('ProjectsTable',{attrs:{"data":_vm.items},on:{"change":_vm.requestData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cv56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPerProjectPickers_vue__ = __webpack_require__("gv15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd1912b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPerProjectPickers_vue__ = __webpack_require__("vOtI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPerProjectPickers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd1912b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPerProjectPickers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DYIK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding"},[_c('Loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('UsersTable',{attrs:{"data":_vm.items},on:{"change":_vm.requestData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dje8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DragableTree',
    props: {
        model: Object,
        hoverId: String,
        sortByHours: Boolean,
        sortByName: Boolean
    },
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a
    },
    computed: {
        hasChildrens: function hasChildrens() {
            return this.model.children && this.model.children.length;
        }
    },
    created: function created() {
        this.sort();
    },
    data: function data() {
        return {
            options: {
                ghostClass: 'ghost',
                sort: false
            },
            drag: false,
            draggedId: false,
            hoverIdNotProp: '',
            changeName: '',
            expanded: false,
            iconsVisibility: true,
            byHours: false,
            byName: true
        };
    },

    watch: {
        hoverId: function hoverId(newValue) {
            this.hoverIdNotProp = newValue;
        },
        sortByHours: function sortByHours(newValue) {
            this.byName = false;
            this.byHours = true;
            this.recursiveSortByHours(this.model);
        },
        sortByName: function sortByName(newValue) {
            this.byName = true;
            this.byHours = false;
            this.recursiveSortByName(this.model);
        }
    },
    methods: {
        drop: function drop(hoverId, newElem, prev) {
            return this.paste(hoverId, newElem, prev);
        },
        hover: function hover(e) {
            this.hoverIdNotProp = e.target.id;
        },
        onStart: function onStart(e) {
            this.drag = true;
            this.draggedId = e.item.id;
        },
        hasChildren: function hasChildren(element) {
            return element.children.length > 0 ? true : false;
        },
        onEnd: function onEnd(e) {
            var _this = this;

            this.drag = false;
            var targetIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (elem) {
                return elem.name === _this.hoverIdNotProp;
            });
            var draggedIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (elem) {
                return elem.name === _this.draggedId;
            });
            if (targetIndex !== -1 && draggedIndex !== -1 && targetIndex !== draggedIndex) {
                var newElem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(this.model.children[draggedIndex]);
                newElem.level++;
                this.model.children[targetIndex].children.push(newElem);
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.model.children, function (elem) {
                    return elem.name === _this.draggedId;
                });
                this.clear();
                this.$emit('clear');
            } else {
                if (draggedIndex !== -1) {
                    var _newElem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(this.model.children[draggedIndex]);
                    this.$emit('drop', this.hoverIdNotProp, _newElem, this.model.name);
                }
            }
            this.draggedId = false;
            this.hoverIdNotProp = '';
        },
        paste: function paste(hoverId, dragged, prev) {
            if (hoverId !== dragged.name) {
                if (this.model.name == hoverId && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (child) {
                    return child.name === dragged.name;
                }) == -1) {
                    this.model.children.push(dragged);
                    this.$refs[prev][0].remove(dragged);
                    this.clear();
                    this.$emit('clear');
                } else {
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (child) {
                        return child.name === dragged.name;
                    }) !== -1) {
                        this.clear();
                        this.$emit('clear');
                    } else {
                        var targetIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (child) {
                            return child.name === hoverId;
                        });
                        if (targetIndex !== -1 && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children[targetIndex].children, function (child) {
                            return child.name === dragged.name;
                        }) == -1) {
                            this.model.children[targetIndex].children.push(dragged);
                            this.$refs[prev][0].remove(dragged);
                            this.clear();
                            this.$emit('clear');
                        } else {
                            if (targetIndex !== -1 && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children[targetIndex].children, function (child) {
                                return child.name === dragged.name;
                            }) !== -1) {
                                this.clear();
                                this.$emit('clear');
                            } else {
                                this.prev = prev;
                                this.$emit('drop', hoverId, dragged, this.model.name);
                            }
                        }
                    }
                }
            } else {
                this.clear();
                this.$emit('clear');
            }
        },
        remove: function remove(dragged) {
            var draggedIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (elem) {
                return elem.name === dragged.name;
            });
            if (draggedIndex !== -1) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.remove(this.model.children, function (elem) {
                    return elem.name === dragged.name;
                });
            } else {
                this.$refs[this.prev][0].remove(dragged);
            }
        },
        onClear: function onClear() {
            this.draggedId = false;
            this.hoverIdNotProp = '';
            this.$emit('clear');
            this.clear();
        },
        clear: function clear() {
            var _this2 = this;

            this.draggedId = false;
            this.hoverIdNotProp = '';
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(this.$refs, function (value, key) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(_this2.$refs[key], function (ref) {
                    ref.clear();
                });
            });
            this.sort();
        },
        resursiveHoursSum: function resursiveHoursSum(array, sum) {
            var _this3 = this;

            return array.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sumBy(array, function (elem) {
                return _this3.resursiveHoursSum(elem.children, elem.hours);
            }) + sum : sum;
        },
        updateName: function updateName(name) {
            var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.model.children, function (child) {
                return child.name === name;
            });
            if (index !== -1) {
                this.model.children[index].name = this.changeName;
            }
        },
        expand: function expand(name) {
            this.$refs[name][0].expandChilds();
        },
        expandChilds: function expandChilds(el) {
            this.expanded = el !== undefined ? el : !this.expanded;
        },
        getExpanded: function getExpanded(name) {
            if (this.$refs[name]) {
                return this.$refs[name][0] && this.$refs[name][0].expanded;
            }
        },
        onHideIcons: function onHideIcons() {
            this.iconsVisibility = !this.iconsVisibility;
        },
        hideIcons: function hideIcons() {
            var _this4 = this;

            this.iconsVisibility = !this.iconsVisibility;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(this.$refs, function (value, key) {
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(_this4.$refs[key], function (ref) {
                    ref.onHideIcons();
                });
            });
        },
        up: function up(dragged) {
            this.expanded = false;
            this.$emit('up', dragged, this.model.name);
        },
        pasteUp: function pasteUp(dragged, prev) {
            this.model.children.push(dragged);
            this.$refs[prev][0].remove(dragged);
            this.clear();
            this.$emit('clear');
        },
        recursiveSortByName: function recursiveSortByName(model) {
            var _this5 = this;

            model.children = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(model.children, 'name');
            return model.children.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(model.children, function (element) {
                return _this5.recursiveSortByName(element);
            }) : model;
        },
        recursiveSortByHours: function recursiveSortByHours(model) {
            var _this6 = this;

            model.children = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(model.children, function (element) {
                return _this6.resursiveHoursSum(element.children, element.hours);
            });
            return model.children.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(model.children, function (element) {
                return _this6.recursiveSortByHours(element);
            }) : model;
        },
        sort: function sort() {
            switch (true) {
                case this.byHours:
                    return this.recursiveSortByHours(this.model);
                    break;
                case this.byName:
                    return this.recursiveSortByName(this.model);
                    break;
                default:
                    return this.recursiveSortByName(this.model);
                    break;
            }
        }
    }
});

/***/ }),

/***/ "EjuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n    Nutrition\n    "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"pagination":_vm.pagination,"total-items":_vm.pagination.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.project.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.task.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.user.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.spent_date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.client.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_up")]):_vm._e(),(!props.item.billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_flat")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.is_running)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}}):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.notes))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(" "+_vm._s(props.item.hours))])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n      From "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+"\n    ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJn6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FieJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gjac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caa4c26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("j97D");
function injectStyle (ssrContext) {
  __webpack_require__("T4aZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2caa4c26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2caa4c26_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"bs-example-navbar-collapse-1"}},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"active"},[_c('router-link',{attrs:{"to":"/admin/users"}},[_vm._v("Users")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/admin/timesheet"}},[_vm._v("Timesheet")])],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#bs-example-navbar-collapse-1","aria-expanded":"false"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v("Grandiz!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Dropdown "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("One more separated link")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"navbar-form navbar-left"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Search"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"}},[_vm._v("Submit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Link")])]),_vm._v(" "),_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Dropdown "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Separated link")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I+E7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsTable_vue__ = __webpack_require__("t0s9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e86aed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsTable_vue__ = __webpack_require__("R32Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e86aed6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I6up":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);






var AxiosApiService = function () {
    function AxiosApiService(url) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AxiosApiService);

        this.url = url;
        this.setHeaders();
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AxiosApiService, [{
        key: 'setHeaders',
        value: function setHeaders() {
            var access_token = this.access_token;
            var account_id = this.account_id;
            if (!access_token || !account_id || account_id == 'undefined' || access_token == 'undefined' || access_token == null || account_id == null) {
                this.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
                    baseURL: this.url
                });
            } else {
                this.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
                    baseURL: this.url,
                    headers: {
                        'Authorization': 'Bearer ' + access_token,
                        'Harvest-Account-Id': account_id
                    }
                });
            }
        }
    }, {
        key: 'get',
        value: function get() {
            var _axios;

            return (_axios = this.axios).get.apply(_axios, arguments);
        }
    }, {
        key: 'post',
        value: function post() {
            var _axios2;

            return (_axios2 = this.axios).post.apply(_axios2, arguments);
        }
    }, {
        key: 'put',
        value: function put() {
            var _axios3;

            return (_axios3 = this.axios).put.apply(_axios3, arguments);
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _axios4;

            return (_axios4 = this.axios).delete.apply(_axios4, arguments);
        }
    }, {
        key: 'setCredentials',
        value: function setCredentials(authData, scope) {
            __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('harvest_token', authData.access_token, { expires: authData.expires_in });
            var account_id = '';

            if (String(scope).indexOf(':') !== -1) {
                try {
                    var _scope$split = scope.split(':'),
                        _scope$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_scope$split, 2),
                        scopeName = _scope$split2[0],
                        id = _scope$split2[1];

                    account_id = id;
                } catch (error) {
                    console.log('error', error);
                }
            } else {
                account_id = scope;
            }

            __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set('harvest_account_id', account_id);
            this.setHeaders();
        }
    }, {
        key: 'access_token',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('harvest_token');
        }
    }, {
        key: 'account_id',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.get('harvest_account_id');
        }
    }]);

    return AxiosApiService;
}();

/* harmony default export */ __webpack_exports__["a"] = (AxiosApiService);

/***/ }),

/***/ "IVUo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "JLEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-example',{attrs:{"data":_vm.data,"width":1200,"height":400}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JxNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timesheet_vue__ = __webpack_require__("1CQK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ce6d8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timesheet_vue__ = __webpack_require__("swVK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timesheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ce6d8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timesheet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K7I/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LDWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('img',{attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Lu2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    data: function data() {
        return {
            msg: 'Please wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080'
        };
    },
    created: function created() {
        var _this = this;

        var access_token = __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Axios().Api.access_token;
        var account_id = __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Axios().Api.account_id;
        var parsed = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);
        __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Auth().signIn(parsed).then(function (res) {
            return __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Axios().Api.setCredentials(res.data, parsed.scope);
        }).then(function () {
            return setTimeout(function () {
                return _this.$router.push('/admin/dashboard');
            }, 1000);
        }).catch(function (err) {
            console.log('ERROR', err);
            _this.$router.push('/');
        });
    },

    methods: {
        auth: function auth() {}
    }
});

/***/ }),

/***/ "M8ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"padding"},[_c('v-card',{staticClass:"margin"},[_c('v-container',{attrs:{"fluid":""}},[_c('ReportsPickers',{on:{"change":_vm.setDates}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('ClientSelector',{on:{"selected":_vm.selectClient}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('ProjectSelector',{attrs:{"clientId":_vm.client_id},on:{"selected":_vm.selectProject}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"right":"","flat":""},on:{"click":function($event){_vm.hideIcons()}}},[_vm._v("Hide Icons")]),_vm._v(" "),_c('v-btn',{attrs:{"right":"","flat":""},on:{"click":function($event){_vm.requestData()}}},[_vm._v("Explore")])],1)],1),_vm._v(" "),(!_vm.loading && (_vm.report.firstPart &&_vm.report.secondPart))?_c('v-card',{staticClass:"margin"},[_c('v-card-title',[_vm._v("\n            Report\n            "),_c('v-spacer')],1),_vm._v(" "),_c('div',{staticClass:"clt"},[_c('DragableTree',{ref:"tree",attrs:{"sortByHours":_vm.byHours,"sortByName":_vm.byName,"model":_vm.report.firstPart}})],1),_vm._v(" "),_c('div',{staticClass:"underline"}),_vm._v(" "),_c('div',{staticClass:"clt"},[_c('DragableTree',{attrs:{"sortByHours":_vm.byHours,"sortByName":_vm.byName,"model":_vm.report.secondPart}})],1)],1):_vm._e(),_vm._v(" "),_c('Loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading ),expression:"loading "}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352516be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("K7I/");
function injectStyle (ssrContext) {
  __webpack_require__("t7us")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352516be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mbt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectSelector_vue__ = __webpack_require__("ysuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f57102_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectSelector_vue__ = __webpack_require__("5CC8");
function injectStyle (ssrContext) {
  __webpack_require__("1rI3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f57102_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N/5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSelector_vue__ = __webpack_require__("cPIG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51402bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSelector_vue__ = __webpack_require__("iVZO");
function injectStyle (ssrContext) {
  __webpack_require__("bwqB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51402bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NH9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPerProjectBarChart_vue__ = __webpack_require__("72c7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_278b6dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPerProjectBarChart_vue__ = __webpack_require__("cSK1");
function injectStyle (ssrContext) {
  __webpack_require__("FieJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPerProjectBarChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_278b6dc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPerProjectBarChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_MaterialIcons_css__ = __webpack_require__("A9U2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_css_MaterialIcons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_css_MaterialIcons_css__);






__webpack_require__("7zck");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
    theme: {
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OPR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPerUsers_vue__ = __webpack_require__("r+3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d821a4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPerUsers_vue__ = __webpack_require__("BITU");
function injectStyle (ssrContext) {
  __webpack_require__("VN2s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectPerUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d821a4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectPerUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmlM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R+zV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersTable_vue__ = __webpack_require__("sNeM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a4b27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersTable_vue__ = __webpack_require__("sQvw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19a4b27a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R32Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n        Projects List\n        "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"pagination":_vm.pagination,"total-items":_vm.pagination.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.client.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.is_billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_up")]):_vm._e(),_vm._v(" "),(!props.item.is_billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_flat")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.is_active)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("thumb_up")]):_vm._e(),_vm._v(" "),(!props.item.is_active)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("thumb_down")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.created))])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n            From "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+"\n        ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T4aZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tf3A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("Xu7m");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            drawer: false
        };
    },

    components: {
        SideBar: __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]
    },
    methods: {
        auth: function auth() {}
    }
});

/***/ }),

/***/ "VN2s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VOQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__("+vOg");





var Api = function Api() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Api);
};

Api.Users = function () {
    return UsersApi;
};

Api.Auth = function () {
    return AuthApi;
};

Api.Timesheets = function () {
    return TimesheetsApi;
};

Api.Axios = function () {
    return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */];
};

Api.Analytics = function () {
    return Analytics;
};

Api.Projects = function () {
    return Projects;
};

Api.Reports = function () {
    return Reports;
};

Api.Clients = function () {
    return Clients;
};

Api.Payments = function () {
    return Payments;
};

var UsersApi = function () {
    function UsersApi() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UsersApi);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(UsersApi, null, [{
        key: 'list',
        value: function list(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/users', { params: params });
        }
    }, {
        key: 'updateRate',
        value: function updateRate(id, data) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.post('/users/' + id + '/rate', data, {
                withCredentials: true
            });
        }
    }]);

    return UsersApi;
}();

var AuthApi = function () {
    function AuthApi() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthApi);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(AuthApi, null, [{
        key: 'signIn',
        value: function signIn(authData) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.post('/authorization/token', authData);
        }
    }]);

    return AuthApi;
}();

var TimesheetsApi = function () {
    function TimesheetsApi() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TimesheetsApi);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(TimesheetsApi, null, [{
        key: 'get',
        value: function get(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/timesheets', {
                params: params
            });
        }
    }]);

    return TimesheetsApi;
}();

var Analytics = function () {
    function Analytics() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Analytics);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Analytics, null, [{
        key: 'UsersPerProject',
        value: function UsersPerProject(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/analytics/users-per-project', {
                params: params
            });
        }
    }, {
        key: 'ProjectsPerUsers',
        value: function ProjectsPerUsers(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/analytics/projects-per-users', {
                params: params
            });
        }
    }]);

    return Analytics;
}();

var Projects = function () {
    function Projects() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Projects);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Projects, null, [{
        key: 'list',
        value: function list(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/projects', { params: params });
        }
    }, {
        key: 'all',
        value: function all(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/projects/all', { params: params });
        }
    }]);

    return Projects;
}();

var Reports = function () {
    function Reports() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Reports);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Reports, null, [{
        key: 'get',
        value: function get(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/reports', { params: params });
        }
    }]);

    return Reports;
}();

var Clients = function () {
    function Clients() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Clients);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Clients, null, [{
        key: 'all',
        value: function all(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/clients/all', { params: params });
        }
    }]);

    return Clients;
}();

var Payments = function () {
    function Payments() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Payments);
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_createClass___default()(Payments, null, [{
        key: 'get',
        value: function get(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.get('/payments', { params: params });
        }
    }, {
        key: 'post',
        value: function post(params) {
            return __WEBPACK_IMPORTED_MODULE_3____["b" /* Axios */].Api.post('/payments/post', { params: params });
        }
    }]);

    return Payments;
}();

/***/ }),

/***/ "VwHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainTemplate_vue__ = __webpack_require__("Tf3A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189efdb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainTemplate_vue__ = __webpack_require__("uOh/");
function injectStyle (ssrContext) {
  __webpack_require__("bx9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-189efdb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_189efdb4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WInu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XN6g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data'],
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      headers: [{
        text: 'Project',
        sortable: false,
        value: 'project.name'
      }, { text: 'User', sortable: false, value: 'user.name' }, { text: 'Billable', sortable: false, value: 'billable' }, { text: 'Notes', sortable: false, value: 'notes' }, { text: 'Hours', sortable: false, value: 'hours' }],
      items: []
    };
  },

  watch: {
    data: function data(newValue) {
      console.log('newValue');
      this.items = newValue.time_entries;
      this.pagination = {
        page: newValue.page,
        rowsPerPage: newValue.per_page,
        totalItems: newValue.total_entries
      };
    }

  },
  created: function created() {
    console.log('this.data', this.data);
    console.log('this.data', this.data);
    this.items = this.data.time_entries;
  }
});

/***/ }),

/***/ "Xu7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("jJKI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de12078e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("t98g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de12078e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YSro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{directives:[{name:"show",rawName:"v-show",value:(_vm.expanded || _vm.model.level==0),expression:"expanded || model.level==0"}],attrs:{"options":_vm.options},on:{"start":_vm.onStart,"end":_vm.onEnd},model:{value:(_vm.model.children),callback:function ($$v) {_vm.$set(_vm.model, "children", $$v)},expression:"model.children"}},_vm._l((_vm.model.children),function(element){return _c('li',{key:element.name,staticClass:"drag-elem",class:{ 'drag-elem-active':_vm.hoverIdNotProp=== element.name && _vm.hoverIdNotProp!== _vm.draggedId,'last':_vm.hasChildren },attrs:{"id":element.name},on:{"dragover":_vm.hover}},[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(element.children.length>0 && !_vm.getExpanded(element.name) && _vm.iconsVisibility),expression:"element.children.length>0 && !getExpanded(element.name) && iconsVisibility"}],attrs:{"id":element.name},on:{"click":function($event){_vm.expand(element.name)}}},[_vm._v("add\n\n        ")]),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(element.children.length>0 && _vm.getExpanded(element.name) && _vm.iconsVisibility),expression:"element.children.length>0 && getExpanded(element.name) && iconsVisibility"}],attrs:{"id":element.name},on:{"click":function($event){_vm.expand(element.name)}}},[_vm._v("remove\n\n        ")]),_vm._v(" "),_c('v-edit-dialog',{attrs:{"lazy":"","id":element.name},on:{"open":function($event){_vm.changeName = element.name},"close":function($event){_vm.updateName(element.name)}}},[_vm._v("\n            "+_vm._s(element.name)+"\n\n\n            "),_c('v-text-field',{attrs:{"slot":"input","label":"Edit","single-line":""},slot:"input",model:{value:(_vm.changeName),callback:function ($$v) {_vm.changeName=$$v},expression:"changeName"}})],1),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconsVisibility && _vm.model.level!==0),expression:"iconsVisibility && model.level!==0"}],attrs:{"id":element.name},on:{"click":function($event){_vm.up(element)}}},[_vm._v("arrow_upward\n        ")]),_vm._v(" "),_c('span',{staticClass:"sum-hours-label",attrs:{"id":element.name}},[_vm._v(" "+_vm._s(_vm.resursiveHoursSum(element.children, element.hours).toFixed(2))+" h ")]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasChildren ),expression:"hasChildren "}],class:{'tree':_vm.model.name==='firstPart'||_vm.model.name==='secondPart'}},[_c('DragableTree',{ref:element.name,refInFor:true,attrs:{"hoverId":_vm.hoverIdNotProp,"model":element},on:{"up":_vm.pasteUp,"clear":_vm.onClear,"drop":_vm.drop}})],1)],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Authorization__ = __webpack_require__("8dt8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Admin_Users_Users_vue__ = __webpack_require__("5CYk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin_TimeSheets_Timesheet_vue__ = __webpack_require__("JxNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Admin_Components__ = __webpack_require__("/ek7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Admin_Dashboard_Dashboard_vue__ = __webpack_require__("cKtv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Admin_Dashboard_Activity_NowActivity_vue__ = __webpack_require__("/pOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Admin_Projects_Projects_vue__ = __webpack_require__("CDWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Admin_Reports_Reports_vue__ = __webpack_require__("0ZlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Admin_Analytics_UsersPerProject_UsersPerProject_vue__ = __webpack_require__("aZ6u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Admin_Analytics_ProjectPerUsers_ProjectPerUsers_vue__ = __webpack_require__("OPR9");














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Hello',
        component: __WEBPACK_IMPORTED_MODULE_2__components_HelloWorld__["a" /* default */]
    }, {
        path: '/auth',
        name: 'AuthPage',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Authorization__["a" /* default */]
    }, {
        path: '/admin/',
        name: 'Home',
        component: __WEBPACK_IMPORTED_MODULE_6__components_Admin_Components__["a" /* default */].MainTemplate,
        children: [
        //-----------------------Users----------------
        {

            path: '/admin/users',
            component: __WEBPACK_IMPORTED_MODULE_4__components_Admin_Users_Users_vue__["a" /* default */]
        }, {

            path: '/admin/projects',
            component: __WEBPACK_IMPORTED_MODULE_9__components_Admin_Projects_Projects_vue__["a" /* default */]
        }, {

            path: '/admin/dashboard',
            component: __WEBPACK_IMPORTED_MODULE_7__components_Admin_Dashboard_Dashboard_vue__["a" /* default */]
        }, {

            path: '/admin/timesheet',
            component: __WEBPACK_IMPORTED_MODULE_5__components_Admin_TimeSheets_Timesheet_vue__["a" /* default */]
        }, {

            path: '/admin/reports',
            component: __WEBPACK_IMPORTED_MODULE_10__components_Admin_Reports_Reports_vue__["a" /* default */]
        }, {

            path: '/admin/analytics/users-per-project',
            component: __WEBPACK_IMPORTED_MODULE_11__components_Admin_Analytics_UsersPerProject_UsersPerProject_vue__["a" /* default */]
        }, {

            path: '/admin/analytics/projects-per-user',
            component: __WEBPACK_IMPORTED_MODULE_12__components_Admin_Analytics_ProjectPerUsers_ProjectPerUsers_vue__["a" /* default */]
        }]

    }]
}));

/***/ }),

/***/ "a35H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_randomcolor__ = __webpack_require__("WybQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_randomcolor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_randomcolor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"],
    props: ['data'],
    watch: {
        data: function data(newValue) {}
    },
    created: function created() {},
    mounted: function mounted() {
        this.renderChart({
            labels: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.data.projects, 'name'),
            datasets: [{
                backgroundColor: __WEBPACK_IMPORTED_MODULE_1_randomcolor___default()({
                    luminosity: 'light',
                    count: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.data.projects, 'name').length,
                    hue: 'monochrome'
                }),
                data: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.data.projects, 'totalHours')
            }]
        }, {
            responsive: true,
            maintainAspectRatio: false
        });
    }
});

/***/ }),

/***/ "aLVA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            from: null,
            to: null,
            from_menu: false,
            to_menu: false
        };
    },
    watch: {
        from: function from(newValue) {
            console.log('from newValue', newValue);
            if (this.to && this.to !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        },
        to: function to(newValue) {
            console.log('to newValue22222', newValue);
            if (this.from && this.from !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: this.from,
                    to: newValue
                });
            }
        }
    }
});

/***/ }),

/***/ "aZ6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPerProject_vue__ = __webpack_require__("iOeB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862d226c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPerProject_vue__ = __webpack_require__("02Jk");
function injectStyle (ssrContext) {
  __webpack_require__("QmlM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersPerProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_862d226c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersPerProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bhN0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [{
        label: 'Data One',
        backgroundColor: '#f87979',
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ "bheL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsPickers_vue__ = __webpack_require__("aLVA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a19d028_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsPickers_vue__ = __webpack_require__("xrrl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsPickers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a19d028_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsPickers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bwqB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bx9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c56i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectsTable_vue__ = __webpack_require__("I+E7");
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Projects',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            loading: true
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__["a" /* default */],
        ProjectsTable: __WEBPACK_IMPORTED_MODULE_3__ProjectsTable_vue__["a" /* default */]
    },
    created: function created() {},

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Projects().list(params).then(function (res) {
                return _this.items = res.data;
            }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                console.log('error:', err);
                return _this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "cKtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("/672");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7323eda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("AOEJ");
function injectStyle (ssrContext) {
  __webpack_require__("z0Gl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7323eda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cPIG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            loading: false,
            items: [],
            search: null,
            select: false,
            states: []
        };
    },

    watch: {
        search: function search(val) {
            val;
        },
        select: function select(newVal) {
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNumber(newVal)) {
                console.log('clientId', newVal);
                this.$emit('selected', newVal);
            } else {
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(newVal)) {
                    this.$emit('selected');
                }
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Clients().all().then(function (res) {
            console.log('CLIENTS: ', res.data);
            return _this.items = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(res.data, function (client) {
                return client.name;
            });
        }).then(function () {
            return _this.loading = false;
        }).catch(function (err) {
            console.log('ERRRR', err);
            _this.loading = false;
        });
    },

    methods: {
        querySelections: function querySelections(name) {
            // setTimeout(() => {
            //     this.items = this.items.filter(e => {
            //         return (name || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            //     })
            //     this.loading = false
            // }, 500)
        }
    }
});

/***/ }),

/***/ "cSK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-example',{attrs:{"data":_vm.data,"width":1200,"height":400}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d2P5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ekz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UsersTable_vue__ = __webpack_require__("R+zV");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Users',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            loading: true
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__["a" /* default */],
        UsersTable: __WEBPACK_IMPORTED_MODULE_3__UsersTable_vue__["a" /* default */]
    },
    created: function created() {},

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this = this;

            console.log('params!!!!1', params);
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Users().list(params).then(function (res) {
                return _this.items = res.data;
            }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                console.log('ERRRR');_this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "fcdg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services___ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            amount: null,
            project: null,
            paymentDate: null,
            menu: null,
            payments: []

        };
    },


    methods: {
        submit: function submit() {
            var params = {
                amount: this.amount,
                project: this.project,
                date: this.paymentDate
            };

            return __WEBPACK_IMPORTED_MODULE_0__services___["a" /* Api */].Payments().post(params);
        },
        isDisabled: function isDisabled() {
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.amount) && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.project) && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.paymentDate)) {
                return false;
            }

            return true;
        }
    },
    mounted: function mounted() {
        return __WEBPACK_IMPORTED_MODULE_0__services___["a" /* Api */].Payments().get().then(function (response) {
            console.log('response:', response);
        });
    }
});

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408ed016_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("3oRF");
function injectStyle (ssrContext) {
  __webpack_require__("WInu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-408ed016"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408ed016_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gv15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            from: null,
            to: null,
            from_menu: false,
            to_menu: false
        };
    },
    watch: {
        from: function from(newValue) {
            if (this.to && this.to !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        },
        to: function to(newValue) {
            if (this.from && this.from !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        }
    }
});

/***/ }),

/***/ "haK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n    Running tasks\n    "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.project.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.user.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(props.item.billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_up")]):_vm._e(),(!props.item.billable)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("trending_flat")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.notes))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.hours))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey"}})],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data'],
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || 'Input too long!';
      },
      tmp: '',
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      headers: [{
        text: 'Project',
        align: 'left',
        sortable: false,
        value: 'project.name'
      }, { text: 'Task', value: 'task.name' }, { text: 'User', value: 'user.name' }, { text: 'Spent Date', value: 'spent_date' }, { text: 'Client', value: 'client.name' }, { text: 'Billable', value: 'billable' }, { text: 'Is Running', value: 'is_running' }, { text: 'Notes', value: 'notes' }, { text: 'Hours', value: 'hours' }],
      items: []
    };
  },

  watch: {
    data: function data(newValue) {
      console.log('newValue');
      this.items = newValue.time_entries;
      this.pagination = {
        page: newValue.page,
        rowsPerPage: newValue.per_page,
        totalItems: newValue.total_entries
      };
    },
    pagination: function pagination(newValue, oldValue) {
      console.log('pagination', newValue);
      if (!oldValue || oldValue.page == newValue.page && oldValue.rowsPerPage == newValue.rowsPerPage) return;
      this.$emit('change', {
        page: newValue.page,
        per_page: newValue.rowsPerPage
      });
    }
  },
  created: function created() {
    console.log('this.data', this.data);
    console.log('this.data', this.data);
    this.items = this.data.time_entries;
  }
});

/***/ }),

/***/ "iHgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            from: null,
            to: null,
            from_menu: false,
            to_menu: false
        };
    },
    watch: {
        from: function from(newValue) {
            if (this.to && this.to !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        },
        to: function to(newValue) {
            if (this.from && this.from !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: this.from,
                    to: newValue
                });
            }
        }
    }
});

/***/ }),

/***/ "iOeB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UsersPerProjectPickers_vue__ = __webpack_require__("Cv56");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserPerProjectBarChart_vue__ = __webpack_require__("NH9Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserPerProjectPieChart_vue__ = __webpack_require__("nGgC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UsersPerProject',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            loading: true,
            params: {
                from: new Date(new Date() - 1000 * 60 * 60 * 24 * 31 - 1).toISOString(),
                to: new Date().toISOString()
            }
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__["a" /* default */],
        UsersPerProjectPickers: __WEBPACK_IMPORTED_MODULE_3__UsersPerProjectPickers_vue__["a" /* default */],
        UserPerProjectBarChart: __WEBPACK_IMPORTED_MODULE_4__UserPerProjectBarChart_vue__["a" /* default */],
        UserPerProjectPieChart: __WEBPACK_IMPORTED_MODULE_5__UserPerProjectPieChart_vue__["a" /* default */]
    },
    created: function created() {
        var _this = this;

        var parsed = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);
        if (parsed.user_id) this.params.user_id = parsed.user_id;
        __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Analytics().UsersPerProject(this.params).then(function (res) {
            return _this.items = res.data;
        }).then(function () {
            return _this.loading = false;
        }).catch(function (err) {
            _this.loading = false;
        });
    },

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Analytics().UsersPerProject(params).then(function (res) {
                return _this2.items = res.data;
            }).then(function () {
                return _this2.loading = false;
            }).catch(function (err) {
                _this2.loading = false;
            });
        },
        submit: function submit() {}
    }
});

/***/ }),

/***/ "iVZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',[_c('v-select',{attrs:{"label":"Clients","autocomplete":"","loading":_vm.loading,"required":"","items":_vm.items,"search-input":_vm.search,"item-text":"name","item-value":"id"},on:{"update:searchInput":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j97D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"sk-folding-cube"},[_c('div',{staticClass:"sk-cube1 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube2 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube4 sk-cube"}),_vm._v(" "),_c('div',{staticClass:"sk-cube3 sk-cube"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jJKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            items: [{
                icon: 'dashboard',
                title: 'Dashboard',
                link: '/admin/dashboard'
            }, {
                icon: 'alarm_add',
                title: 'Timesheets',
                link: '/admin/timesheet'
            }, {
                icon: 'people',
                title: 'Users',
                link: '/admin/users'
            }, {
                icon: 'receipt',
                title: 'Projects',
                link: '/admin/projects'
            }, {
                icon: 'credit_card',
                title: 'Reports',
                link: '/admin/reports'
            }, {
                icon: 'people',
                title: 'Analytics',
                link: '/users',
                items: [{
                    icon: 'book',
                    title: 'Users Per Projects',
                    link: '/admin/analytics/users-per-project'
                }, {
                    icon: 'school',
                    title: 'Projects Per Users',
                    link: '/admin/analytics/projects-per-user'
                }]
            }]
        };
    },

    methods: {
        navigate: function navigate(item) {
            if (!item.items) this.$router.push(item.link);
        }
    }
});

/***/ }),

/***/ "lW66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DragableTree_vue__ = __webpack_require__("Dje8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6750689f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DragableTree_vue__ = __webpack_require__("YSro");
function injectStyle (ssrContext) {
  __webpack_require__("FJn6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DragableTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6750689f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DragableTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.0.0","/home/vlad/domains/harvest-analytics/public"]],"_from":"vue-chartjs@3.0.0","_id":"vue-chartjs@3.0.0","_inBundle":false,"_integrity":"sha512-XDe1iIYhQdr0L3MvxdWrqhsq/pyB4I1/e8QZ8OfYCmpoOhelauWgjeT9HzK7oLqou5n8khEcAaa4WEUceqK8rA==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.0.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.0.0","saveSpec":null,"fetchSpec":"3.0.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.0.tgz","_spec":"3.0.0","_where":"/home/vlad/domains/harvest-analytics/public","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"6.4.1","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"12.2.2","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.0","vue":"2.5.2"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"3.0.0"}

/***/ }),

/***/ "lrD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_DragableTree_vue__ = __webpack_require__("lW66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProjectSelector_vue__ = __webpack_require__("Mbt3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClientSelector_vue__ = __webpack_require__("N/5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReportsPickers_vue__ = __webpack_require__("bheL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Reports',
    data: function data() {
        return {
            items: [],
            data: [],
            loading: false,
            report: {
                firstPart: false,
                secondPart: false
            },
            project_id: false,
            client_id: false,
            params: {},
            byHours: true,
            byName: false
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__["a" /* default */],
        ProjectSelector: __WEBPACK_IMPORTED_MODULE_5__ProjectSelector_vue__["a" /* default */],
        ClientSelector: __WEBPACK_IMPORTED_MODULE_6__ClientSelector_vue__["a" /* default */],
        ReportsPickers: __WEBPACK_IMPORTED_MODULE_7__ReportsPickers_vue__["a" /* default */],
        DragableTree: __WEBPACK_IMPORTED_MODULE_4__Components_DragableTree_vue__["a" /* default */]
    },
    created: function created() {},

    methods: {
        auth: function auth() {},
        requestData: function requestData() {
            var _this = this;

            this.report = {
                firstPart: false,
                secondPart: false
            };
            this.loading = true;

            console.log("PARAMS: ", this.params);

            __WEBPACK_IMPORTED_MODULE_1__services__["a" /* Api */].Reports().get(this.params).then(function (res) {

                console.log(res);

                res.data.firstPart.level = 0;
                res.data.secondPart.level = 0;
                _this.report = res.data;
            }).then(function () {
                return _this.loading = false;
            });
        },
        selectProject: function selectProject(project_id) {

            console.log("selectProject", project_id);

            this.params.project_id = project_id;
            if (!project_id) {
                delete this.params.project_id;
            }
        },
        selectClient: function selectClient(client_id) {

            console.log("selectClient", client_id);

            this.params.client_id = client_id;
            this.params.project_id = null;
            this.client_id = client_id;
            if (!client_id) {
                delete this.params.client_id;
            }
        },
        setDates: function setDates(params) {
            console.log('params', params);
            this.params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, params);
        },
        hideIcons: function hideIcons() {
            console.log('this.$refs', this.$refs);
            this.$refs.tree.hideIcons();
        }
    }
});

/***/ }),

/***/ "lsD3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lssb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    }
});

/***/ }),

/***/ "m4o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            from: null,
            to: null,
            from_menu: false,
            to_menu: false
        };
    },
    watch: {
        from: function from(newValue) {
            console.log('from newValue', newValue);
            if (this.to && this.to !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        },
        to: function to(newValue) {
            console.log('to newValue', newValue);
            if (this.from && this.from !== null && newValue && newValue !== null) {
                this.$emit('change', {
                    from: newValue,
                    to: this.to
                });
            }
        }
    }
});

/***/ }),

/***/ "mj8Y":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "el6m",
	"./af.js": "el6m",
	"./ar": "k/LX",
	"./ar-dz": "8sQJ",
	"./ar-dz.js": "8sQJ",
	"./ar-kw": "Ypiv",
	"./ar-kw.js": "Ypiv",
	"./ar-ly": "vFBa",
	"./ar-ly.js": "vFBa",
	"./ar-ma": "5srG",
	"./ar-ma.js": "5srG",
	"./ar-sa": "OWdl",
	"./ar-sa.js": "OWdl",
	"./ar-tn": "zbnz",
	"./ar-tn.js": "zbnz",
	"./ar.js": "k/LX",
	"./az": "+TbT",
	"./az.js": "+TbT",
	"./be": "I3+K",
	"./be.js": "I3+K",
	"./bg": "6pzG",
	"./bg.js": "6pzG",
	"./bn": "BSxz",
	"./bn.js": "BSxz",
	"./bo": "xZM4",
	"./bo.js": "xZM4",
	"./br": "z7xq",
	"./br.js": "z7xq",
	"./bs": "CRbE",
	"./bs.js": "CRbE",
	"./ca": "vtJn",
	"./ca.js": "vtJn",
	"./cs": "50M2",
	"./cs.js": "50M2",
	"./cv": "imKR",
	"./cv.js": "imKR",
	"./cy": "0GzN",
	"./cy.js": "0GzN",
	"./da": "w5+c",
	"./da.js": "w5+c",
	"./de": "EVTu",
	"./de-at": "nG3g",
	"./de-at.js": "nG3g",
	"./de-ch": "Yt6q",
	"./de-ch.js": "Yt6q",
	"./de.js": "EVTu",
	"./dv": "qtbI",
	"./dv.js": "qtbI",
	"./el": "5alt",
	"./el.js": "5alt",
	"./en-au": "z0Rx",
	"./en-au.js": "z0Rx",
	"./en-ca": "3NXy",
	"./en-ca.js": "3NXy",
	"./en-gb": "+etJ",
	"./en-gb.js": "+etJ",
	"./en-ie": "9aRM",
	"./en-ie.js": "9aRM",
	"./en-nz": "nuu6",
	"./en-nz.js": "nuu6",
	"./eo": "ScLw",
	"./eo.js": "ScLw",
	"./es": "dvvA",
	"./es-do": "yg1m",
	"./es-do.js": "yg1m",
	"./es.js": "dvvA",
	"./et": "0unr",
	"./et.js": "0unr",
	"./eu": "RwsK",
	"./eu.js": "RwsK",
	"./fa": "0MmL",
	"./fa.js": "0MmL",
	"./fi": "3jre",
	"./fi.js": "3jre",
	"./fo": "wY+L",
	"./fo.js": "wY+L",
	"./fr": "khqN",
	"./fr-ca": "bEN0",
	"./fr-ca.js": "bEN0",
	"./fr-ch": "S4fe",
	"./fr-ch.js": "S4fe",
	"./fr.js": "khqN",
	"./fy": "1XdY",
	"./fy.js": "1XdY",
	"./gd": "Q4Vj",
	"./gd.js": "Q4Vj",
	"./gl": "ZUnQ",
	"./gl.js": "ZUnQ",
	"./gom-latn": "4dEw",
	"./gom-latn.js": "4dEw",
	"./he": "9PWd",
	"./he.js": "9PWd",
	"./hi": "d8Wo",
	"./hi.js": "d8Wo",
	"./hr": "YkY+",
	"./hr.js": "YkY+",
	"./hu": "79Lb",
	"./hu.js": "79Lb",
	"./hy-am": "DMpe",
	"./hy-am.js": "DMpe",
	"./id": "Ibyo",
	"./id.js": "Ibyo",
	"./is": "L3mU",
	"./is.js": "L3mU",
	"./it": "9XIi",
	"./it.js": "9XIi",
	"./ja": "x5kd",
	"./ja.js": "x5kd",
	"./jv": "30df",
	"./jv.js": "30df",
	"./ka": "JI1o",
	"./ka.js": "JI1o",
	"./kk": "HJwE",
	"./kk.js": "HJwE",
	"./km": "OTi2",
	"./km.js": "OTi2",
	"./kn": "2230",
	"./kn.js": "2230",
	"./ko": "dDkv",
	"./ko.js": "dDkv",
	"./ky": "PHd1",
	"./ky.js": "PHd1",
	"./lb": "vxmX",
	"./lb.js": "vxmX",
	"./lo": "K877",
	"./lo.js": "K877",
	"./lt": "Zk7u",
	"./lt.js": "Zk7u",
	"./lv": "JOTR",
	"./lv.js": "JOTR",
	"./me": "Ex1I",
	"./me.js": "Ex1I",
	"./mi": "jjiy",
	"./mi.js": "jjiy",
	"./mk": "gWcD",
	"./mk.js": "gWcD",
	"./ml": "kBLj",
	"./ml.js": "kBLj",
	"./mr": "V2NI",
	"./mr.js": "V2NI",
	"./ms": "KQOe",
	"./ms-my": "POgm",
	"./ms-my.js": "POgm",
	"./ms.js": "KQOe",
	"./my": "ZAKQ",
	"./my.js": "ZAKQ",
	"./nb": "MQ71",
	"./nb.js": "MQ71",
	"./ne": "PefK",
	"./ne.js": "PefK",
	"./nl": "aSId",
	"./nl-be": "Fpiv",
	"./nl-be.js": "Fpiv",
	"./nl.js": "aSId",
	"./nn": "YpEG",
	"./nn.js": "YpEG",
	"./pa-in": "r+L2",
	"./pa-in.js": "r+L2",
	"./pl": "eXAp",
	"./pl.js": "eXAp",
	"./pt": "I4bD",
	"./pt-br": "iAmb",
	"./pt-br.js": "iAmb",
	"./pt.js": "I4bD",
	"./ro": "tXyB",
	"./ro.js": "tXyB",
	"./ru": "ngkl",
	"./ru.js": "ngkl",
	"./sd": "OWeY",
	"./sd.js": "OWeY",
	"./se": "+EdD",
	"./se.js": "+EdD",
	"./si": "gaPs",
	"./si.js": "gaPs",
	"./sk": "jUKU",
	"./sk.js": "jUKU",
	"./sl": "DQFe",
	"./sl.js": "DQFe",
	"./sq": "M7V7",
	"./sq.js": "M7V7",
	"./sr": "bzhX",
	"./sr-cyrl": "33c5",
	"./sr-cyrl.js": "33c5",
	"./sr.js": "bzhX",
	"./ss": "NejB",
	"./ss.js": "NejB",
	"./sv": "w+2E",
	"./sv.js": "w+2E",
	"./sw": "Dll1",
	"./sw.js": "Dll1",
	"./ta": "jbxT",
	"./ta.js": "jbxT",
	"./te": "jB/5",
	"./te.js": "jB/5",
	"./tet": "VbPC",
	"./tet.js": "VbPC",
	"./th": "nLNk",
	"./th.js": "nLNk",
	"./tl-ph": "mfkQ",
	"./tl-ph.js": "mfkQ",
	"./tlh": "jXJl",
	"./tlh.js": "jXJl",
	"./tr": "92cT",
	"./tr.js": "92cT",
	"./tzl": "5MIk",
	"./tzl.js": "5MIk",
	"./tzm": "0vIq",
	"./tzm-latn": "3+Cq",
	"./tzm-latn.js": "3+Cq",
	"./tzm.js": "0vIq",
	"./uk": "Hd7b",
	"./uk.js": "Hd7b",
	"./ur": "XtGu",
	"./ur.js": "XtGu",
	"./uz": "uRCu",
	"./uz-latn": "1AHx",
	"./uz-latn.js": "1AHx",
	"./uz.js": "uRCu",
	"./vi": "FB03",
	"./vi.js": "FB03",
	"./x-pseudo": "APXS",
	"./x-pseudo.js": "APXS",
	"./yo": "/1ch",
	"./yo.js": "/1ch",
	"./zh-cn": "yEKL",
	"./zh-cn.js": "yEKL",
	"./zh-hk": "sjvb",
	"./zh-hk.js": "sjvb",
	"./zh-tw": "f55z",
	"./zh-tw.js": "f55z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mj8Y";

/***/ }),

/***/ "nGgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPerProjectPieChart_vue__ = __webpack_require__("8o66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d147a87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPerProjectPieChart_vue__ = __webpack_require__("JLEw");
function injectStyle (ssrContext) {
  __webpack_require__("wn9W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserPerProjectPieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d147a87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserPerProjectPieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oizg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"amount","type":"number","required":""},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"project","required":""},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Select Income Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.paymentDate),callback:function ($$v) {_vm.paymentDate=$$v},expression:"paymentDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"title":"Income Date","scrollable":"","autosave":""},model:{value:(_vm.paymentDate),callback:function ($$v) {_vm.paymentDate=$$v},expression:"paymentDate"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isDisabled()},on:{"click":function($event){$event.preventDefault();_vm.submit($event)}}},[_vm._v("Submit")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r+3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProjectPerUsersPickers_vue__ = __webpack_require__("A+rL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Forms_PaymentForm_vue__ = __webpack_require__("0YGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UsersPerProject',
    data: function data() {
        return {
            msg: 'Pleaase wait ...',
            subdomain: 'hat',
            client_id: '-PsAjA85atcU6QvOwHP2qA',
            redirect_uri: 'http://localhost:8080',
            items: [],
            data: {
                headers: [],
                Analytics: []
            },
            params: {
                projectsPage: 1,
                usersPage: 1,
                totalUsers: 1,
                totalProjects: 1,
                from: new Date(new Date() - 1000 * 60 * 60 * 24 * 31 - 1).toISOString(),
                to: new Date().toISOString()
            },
            loading: true
        };
    },

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_3__Components_Loader_vue__["a" /* default */],
        ProjectPerUsersPickers: __WEBPACK_IMPORTED_MODULE_4__ProjectPerUsersPickers_vue__["a" /* default */],
        PaymentForm: __WEBPACK_IMPORTED_MODULE_5__Components_Forms_PaymentForm_vue__["a" /* default */]
    },
    watch: {
        'params.projectsPage': function paramsProjectsPage(newValue, oldValue) {
            if (oldValue !== newValue) {
                this.usersPage = 1;
                this.requestData({
                    projectsPage: newValue
                });
            }
        }
    },
    created: function created() {
        this.requestData();
    },

    methods: {
        auth: function auth() {},
        requestData: function requestData(params) {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__services__["a" /* Api */].Analytics().ProjectsPerUsers(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.params, params)).then(function (res) {
                _this.data = res.data;
                _this.params.totalProjects = res.data.totalProjects;
                _this.params.totalUsers = res.data.totalUsers;
                _this.params.usersPage = res.data.usersPage;
                _this.params.projectsPage = res.data.projectsPage;
                return _this.items;
            }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
            });
        },
        loadMore: function loadMore() {
            var _this2 = this;

            this.params.usersPage++;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__services__["a" /* Api */].Analytics().ProjectsPerUsers(this.params).then(function (res) {
                var newAnalytics = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.concat(_this2.data.Analytics, res.data.Analytics);
                _this2.data = res.data;
                _this2.data.Analytics = newAnalytics;
                _this2.params.totalProjects = res.data.totalProjects;
                _this2.params.totalUsers = res.data.totalUsers;
                _this2.params.usersPage = res.data.usersPage;
                _this2.params.projectsPage = res.data.projectsPage;
                return _this2.items;
            }).then(function () {
                return _this2.loading = false;
            }).catch(function (err) {
                _this2.loading = false;
            });
        },
        goToUser: function goToUser(user_id) {
            this.$router.push('/admin/analytics/users-per-project?user_id=' + user_id);
        }
    }
});

/***/ }),

/***/ "rWqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.from_menu),callback:function ($$v) {_vm.from_menu=$$v},expression:"from_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.to_menu),callback:function ($$v) {_vm.to_menu=$$v},expression:"to_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sNeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['data'],
    data: function data() {
        return {
            max25chars: function max25chars(v) {
                return v.length <= 25 || 'Input too long!';
            },
            tmp: '',
            search: '',
            pagination: {
                rowsPerPage: 10
            },
            headers: [{
                text: 'Avatar',
                align: 'left',
                value: 'avatar_url'
            }, {
                text: 'First Name',
                align: 'left',
                value: 'first_name'
            }, {
                text: 'Last Name',
                value: 'last_name'
            }, {
                text: 'E-Mail',
                value: 'email'
            }, {
                text: 'Rate/hour',
                value: 'rate'
            }, {
                text: 'Roles',
                value: 'roles_view'
            }, {
                text: 'Created',
                value: 'created'
            }],
            items: [],
            rate: 0
        };
    },

    watch: {
        data: function data(newValue) {
            console.log('newValue', newValue);
            this.items = newValue.users;
            this.pagination = {
                page: newValue.page,
                rowsPerPage: newValue.per_page,
                totalItems: newValue.total_entries
            };
            this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.items, function (item) {
                item.created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.created_at).format('L');
                item.roles_view = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(item.roles, ', ');
                return item;
            });
        },
        pagination: function pagination(newValue, oldValue) {
            console.log('pagination', newValue);
            if (!oldValue || oldValue.page == newValue.page && oldValue.rowsPerPage == newValue.rowsPerPage) return;
            this.$emit('change', {
                page: newValue.page,
                per_page: newValue.rowsPerPage
            });
        }
    },
    created: function created() {
        console.log('this.data', this.data);
        this.items = this.data.users;
        this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.items, function (item) {
            item.created = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.created_at).format('L');
            item.roles_view = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(item.roles, ', ');
            item.weekly_capacity_view = (item.weekly_capacity / (60 * 60)).toFixed(2);
            return item;
        });
    },

    methods: {
        updateRate: function updateRate(id, rate) {
            var _this = this;

            console.log('rate', rate);
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Users().updateRate(id, { id: id, rate: rate }).then(function () {
                return _this.loading = false;
            }).catch(function (err) {
                console.log('ERRRR');_this.loading = false;
            });
        }
    }
});

/***/ }),

/***/ "sQvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n            Nutrition\n            "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"pagination":_vm.pagination,"total-items":_vm.pagination.totalItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_c('v-avatar',{attrs:{"slot":"activator","size":"36px"},slot:"activator"},[_c('img',{attrs:{"src":props.item.avatar_url,"alt":""}})])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-edit-dialog',{attrs:{"lazy":""},on:{"open":function($event){_vm.rate = props.item.rate},"close":function($event){_vm.updateRate(props.item.id,props.item.rate)}}},[_vm._v(" "+_vm._s(props.item.rate)+" $\n                        "),_c('v-text-field',{attrs:{"slot":"input","label":"Edit","single-line":"","counter":"","rules":[_vm.max25chars]},slot:"input",model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", $$v)},expression:"props.item.rate"}})],1)],1),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.roles_view))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.created))])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n     From "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+"\n")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "swVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('TimeSheetPickers',{on:{"change":_vm.requestData}}),_vm._v(" "),(_vm.loading)?_c('Loader'):_vm._e(),_vm._v(" "),_c('TimeSheetsTable',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"data":_vm.items},on:{"change":_vm.requestData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t0s9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['data'],
    data: function data() {
        return {
            max25chars: function max25chars(v) {
                return v.length <= 25 || 'Input too long!';
            },
            tmp: '',
            search: '',
            pagination: {
                rowsPerPage: 10
            },
            headers: [{
                text: 'Name',
                align: 'left'
            }, {
                text: 'Client',
                align: 'left',
                value: 'client.name'
            }, {
                text: 'Is Billable',
                value: 'is_billable'
            }, {
                text: 'Is Active',
                value: 'is_active'
            }, {
                text: 'Created',
                value: 'created'
            }],
            items: []
        };
    },

    watch: {
        data: function data(newValue) {
            this.items = newValue.projects;
            this.pagination = {
                page: newValue.page,
                rowsPerPage: newValue.per_page,
                totalItems: newValue.total_entries
            };
            this.items = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.items, function (item) {
                item.created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.created_at).format('L');
                item.roles_view = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(item.roles, ', ');
                return item;
            });
        },
        pagination: function pagination(newValue, oldValue) {
            if (!oldValue || oldValue.page == newValue.page && oldValue.rowsPerPage == newValue.rowsPerPage) return;
            this.$emit('change', {
                page: newValue.page,
                per_page: newValue.rowsPerPage
            });
        }
    },
    created: function created() {
        this.items = this.data.projects;
        this.items = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.items, function (item) {
            item.created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.created_at).format('L');
            item.roles_view = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(item.roles, ', ');
            item.weekly_capacity_view = (item.weekly_capacity / (60 * 60)).toFixed(2);
            return item;
        });
    }
});

/***/ }),

/***/ "t7us":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t98g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.items),function(item,i){return _c('v-list-group',{key:i},[_c('v-list-tile',{attrs:{"slot":"item","ripple":""},nativeOn:{"click":function($event){_vm.navigate(item)}},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""},domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}}),_vm._v(" "),(item.items && item.items.length>0)?_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1):_vm._e()],1),_vm._v(" "),_vm._l((item.items),function(subItem){return _c('v-list-tile',{key:subItem.title,nativeOn:{"click":function($event){_vm.navigate(subItem)}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"dark":""},domProps:{"innerHTML":_vm._s(subItem.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(subItem.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(subItem.action))])],1)],1)})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uOh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-navigation-drawer',{attrs:{"persistent":"","enable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('SideBar')],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Grandiz!")])],1),_vm._v(" "),_c('main',[_c('v-content',[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":"","fixed":""}},[_c('span',[_vm._v("© 2017")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uewz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("lssb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71908983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("HMO7");
function injectStyle (ssrContext) {
  __webpack_require__("XN6g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71908983"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71908983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vOtI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.from_menu),callback:function ($$v) {_vm.from_menu=$$v},expression:"from_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","sm5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.to_menu),callback:function ($$v) {_vm.to_menu=$$v},expression:"to_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wn9W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xCAX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),

/***/ "xrrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.from_menu),callback:function ($$v) {_vm.from_menu=$$v},expression:"from_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.to_menu),callback:function ($$v) {_vm.to_menu=$$v},expression:"to_menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Picker in menu","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xty0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"padding",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[(_vm.loading)?_c('Loader'):_vm._e(),_vm._v(" "),_c('NowActivityTable',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"data":_vm.items},on:{"change":_vm.requestData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ysuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__("+vOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Loader_vue__ = __webpack_require__("Gjac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['clientId'],
  data: function data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: false,
      states: []
    };
  },

  watch: {
    clientId: function clientId(val) {
      if (val) {
        this.getProjects(val);
      } else {
        this.select = false;
        this.items = [];
      }
    },
    search: function search(val) {
      val && this.querySelections(val);
    },
    select: function select(selected) {
      if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isArray(selected) && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(selected)) return this.$emit('selected', selected);

      return this.$emit('selected');
    }
  },
  methods: {
    querySelections: function querySelections(name) {},
    getProjects: function getProjects() {
      var _this = this;

      var clientId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__services__["a" /* Api */].Projects().all().then(function (res) {
        _this.items = [];
        console.log('PROJECTS: ', res.data);

        var projectsForClient = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(res.data, function (project) {
          return project.client.id === clientId;
        });
        return _this.items = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(projectsForClient, function (project) {
          return project.name;
        });
      }).then(function () {
        return _this.loading = false;
      }).catch(function (err) {
        console.log('ERRRR', err);
        _this.loading = false;
      });
    }
  },

  mounted: function mounted() {
    console.log("CLIENT_ID: ", this.client_id);
  }
});

/***/ }),

/***/ "z0Gl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cccbd88017ad77e6e6e0.js